<template>
  <section v-if="viewMode === 'list'" class="bic-list">
    <div class="bic-list__bic-item-wrapper"
      v-for="item in filteredItems"
      :key="item.id"
    >
      <BicItem 
        v-show="item.code !== alternateBicSource || alternateBicLoading === true || !alternateBic"
        :item="item"
        :selected="selectedIds.indexOf(item.id)!==-1"
        :addToWatchlist="() => addToWatchlist(item)"
        :removeFromWatchlist="() => removeFromWatchlist({ id: item.id })"
        :showHelp="(itemsHelp === item.code)"
        :toggleBicsHelp="() => toggleBicsHelp({code: item.code})"
        :getAlternateBicForSource="(payload) => getAlternateBic({ ...payload, source_code: item.code})"
      />
      <BicItemAlternate
        v-if="item.code === alternateBicSource && alternateBicLoading === false && alternateBic"
        :item="alternateBic"
        :clearAlternateBic="clearAlternateBic"
      />
    </div>
  </section>

  <section v-else-if="viewMode === 'grid'" class="bic-list bic-list--grid u-clearfix">
    <div v-for="n in 3" class="bic-list__column" :key="n">
      <div class="bic-list__bic-item-wrapper"
        v-for="item in filteredItemsColumn(n)"
        :key="item.id"
      >
        <BicItem 
          v-show="item.code !== alternateBicSource || alternateBicLoading === true || !alternateBic"
          :item="item"
          :selected="selectedIds.indexOf(item.id)!==-1"
          :addToWatchlist="() => addToWatchlist(item)"
          :removeFromWatchlist="() => removeFromWatchlist({ id: item.id })"
          :showHelp="(itemsHelp === item.code)"
          :toggleBicsHelp="() => toggleBicsHelp({code: item.code})"
          :getAlternateBicForSource="(payload) => getAlternateBic({ ...payload, source_code: item.code})"
        />
        <BicItemAlternate
          v-if="item.code === alternateBicSource && alternateBicLoading === false && alternateBic"
          :item="alternateBic"
          :clearAlternateBic="clearAlternateBic"
        />
      </div>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue';
  import BicItem from './BicItem.vue';
  import BicItemAlternate from './BicItemAlternate.vue';
  import { isDesktop, onWindowResize } from '../services/dom.js';

  // As the template if different for list or grid, we need to monitor screen resize to update displayList
  // Desktop: default is grid (set on before mount)
  //          if window is resized to tablet, set displayList back to true
  export default Vue.component('BicList', {
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      itemsSelected: {
        type: Array,
        default: () => [],
      },
      alternateBicSource: String,
      alternateBic: Object,
      alternateBicLoading: Boolean,
      showSelected: Boolean,
      displayList: Boolean,
      itemsHelp: String,
      addToWatchlist: Function,
      removeFromWatchlist: Function,
      toggleBicsHelp: Function,
      getAlternateBic: Function,
      clearAlternateBic: Function,
      setDisplayList: Function,
    },
    watch: {
      displayList: function() {
        this.setViewMode();
      }
    },
    data: function() {
      // viewList take into account displayList + the viewport
      // displayList is false by default, but viewList will be true is viewport < desktop
      // if displayList is true, viewList will always be true
      return {
        viewMode: 'grid',
      }
    },
    created: function() {
      this.setViewMode();
      onWindowResize(this.setViewMode);
    },
    computed: {
      // viewMode: function() {
      //   return (!this.displayList && isDesktop()) ? 'grid' : 'list';
      // },
      selectedIds: function() {
        return this.itemsSelected.map(item => item.id);
      },
      filteredItems: function() {
        return (this.showSelected) ? this.itemsSelected : this.items;
      },
      filteredItemsColumn: function() {
        const items = this.filteredItems;
        return function(columnNumber) {
          return items.filter((item, index) => (index)%3 === (columnNumber-1));
        };
      },
    },
    methods: {
      setViewMode() {
        this.viewMode = (!this.displayList && isDesktop()) ? 'grid' : 'list';
      }
    }
  });
</script>